@if (current_path.length > 0) {
  <div class="breadcrumb-panel">
    @for (directory of current_path; track directory; let index = $index) {
      <div class="custom-breadcrumb">
        <div class='name'
          title="{{ directory.details.name }}"
          [class.last]="index === current_path.length - 1"
          (click)="index !== current_path.length - 1 ? setActiveDirectory(directory) : null"
          >
          {{ directory.details.name || '{inv-unknown}' }}
        </div>
        @if (index !== current_path.length - 1) {
          <div class='arrow'>></div>
        }
      </div>
    }
  </div>
}